import { FaEdit, FaEye, FaEyeSlash, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import Input from "../../../components/Input/Input";
import moment from "moment";
import "./StudentTable.css";
export const tableConstants = (
  permissions,
  statusHandler,
  studentDelete,
  isEditMode,
  changeHandler,
  rollNoRefs = [],
  page
) => {
  const toTitleCase = (str = "") =>
    str && str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

  return [
    {
      title: "Sr",
      render: (rowData, index) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {50 * (page - 1) + (index + 1)}
        </span>
      ),
    },
    {
      title: "RollNo",
      key: "roll_no",
      render: (rowData, index) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="roll_no"
              className="input-small"
              value={rowData.roll_no}
              ref={(el) => {
                if (el) rollNoRefs[index] = el;
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Tab") {
                  e.preventDefault();
                  const currentIndex = rollNoRefs.findIndex(
                    (ref) => ref === e.target
                  );
                  const nextInput = rollNoRefs[currentIndex + 1];
                  if (nextInput) nextInput.focus();
                }
              }}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.roll_no
          )}
        </span>
      ),
    },
    {
      title: "Admission_NO",
      key: "id_number",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {rowData.id_number}
        </span>
      ),
    },
    {
      title: "First_Name",
      key: "first_name",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="first_name"
              className="input-large"
              value={rowData.first_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            toTitleCase(rowData.first_name)
          )}
        </span>
      ),
    },
    {
      title: "Last_Name",
      key: "last_name",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="last_name"
              className="input-large"
              value={rowData.last_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            toTitleCase(rowData.last_name)
          )}
        </span>
      ),
    },
    {
      title: "Class",
      key: "class_name",
      render: (rowData) => (
        <span
          className={`cell-class ${
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }`}
        >
          {rowData.programs?.name}
        </span>
      ),
    },
    {
      title: "Date_of_Birth",
      key: "dob",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="date"
              name="dob"
              className="input-medium"
              value={moment(rowData.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.dob
          )}
        </span>
      ),
    },
    {
      title: "Father_Name",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="father_name"
              className="input-xlarge"
              value={rowData.father_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            toTitleCase(rowData.father_name)
          )}
        </span>
      ),
    },
    {
      title: "Mother_Name",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="mother_name"
              className="input-xlarge"
              value={rowData.mother_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            toTitleCase(rowData.mother_name)
          )}
        </span>
      ),
    },
    {
      title: "Apaar_ID",
      key: "apaar_id",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="apaar_id"
              className="input-xlarge"
              value={rowData.apaar_id}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.apaar_id
          )}
        </span>
      ),
    },
    {
      title: "ParentApp",
      key: "is_activated",
      render: (rowData) => (
        <span
          className={`student-badge ${
            Number(rowData.is_activated) === 1
              ? "student-badge-active"
              : "student-badge-inactive"
          }`}
        >
          {Number(rowData.is_activated) === 1 ? "Activated" : "Inactivated"}
        </span>
      ),
    },
    {
      title: "Contact_No",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="phone1"
              className="input-large"
              value={rowData.phone1}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.phone1
          )}
        </span>
      ),
    },
    {
      title: "MoodleID",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="user_name"
              className="input-medium"
              value={rowData.user_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.user_name
          )}
        </span>
      ),
    },
    {
      title: "House_Name",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {isEditMode ? (
            <Input
              type="text"
              name="house_name"
              className="input-medium"
              value={rowData.house_name}
              onChange={(e) => changeHandler(e, rowData.id)}
            />
          ) : (
            rowData.house_name
          )}
        </span>
      ),
    },
    {
      title: "ActivationKey",
      key: "activation_key",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {rowData.activation_key}
        </span>
      ),
    },
    {
      title: "Suspended_Source",
      key: "suspended_source",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {rowData.suspended_source || "-"}
        </span>
      ),
    },
    {
      title: "OTP",
      render: (rowData) => (
        <span
          className={
            Number(rowData.suspended) === 0 ? "text-active" : "text-suspended"
          }
        >
          {rowData.otp || "-"}
        </span>
      ),
    },
    permissions.includes("student.update") && {
      title: "Operation",
      render: (rowData) => (
        <span className="student-action-group">
          {permissions.includes("student.update") &&
            rowData.suspended === 0 && (
              <Link
                to={`/student/update/${rowData.id}`}
                className="student-action-btn edit"
                title="Edit"
              >
                <FaEdit />
              </Link>
            )}
          {permissions.includes("student.update") && (
            <span
              className={`student-action-btn ${
                rowData.suspended === 0 ? "toggle-on" : "toggle-off"
              }`}
              title={rowData.suspended === 0 ? "Active" : "Inactive"}
              onClick={() =>
                window.confirm(
                  `Are you sure you wish to ${
                    rowData.suspended === 0 ? "InActive" : "Active"
                  } the student?`
                ) && statusHandler(rowData.id, rowData.suspended === 0 ? 1 : 0)
              }
            >
              {rowData.suspended === 0 ? <FaEye /> : <FaEyeSlash />}
            </span>
          )}
          {permissions.includes("student.delete") && (
            <span
              className="student-action-btn delete"
              title="Delete"
              onClick={() =>
                window.confirm("Are you sure you wish to delete this item?") &&
                studentDelete(rowData.id)
              }
            >
              <FaTrash />
            </span>
          )}
        </span>
      ),
    },
  ].filter(Boolean); // remove falsy values (for conditional Operation column)
};
